module.exports = __webpack_public_path__ + "static/media/menu.cfc9821f.webp";